import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  email: string;
}

const initialState: UserState = {
  email: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserEmail(state, action: PayloadAction<UserState>) {
      state.email = action.payload.email;
    },
    clearUser() {
      return initialState;
    },
  },
});

export const { setUserEmail, clearUser } = userSlice.actions;
export default userSlice.reducer;
